/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum CapacityUnits {
  MB = 'MB',
  GB = 'GB',
  TB = 'TB',
}

export const UnitsToBytesMultiplier = {
  [CapacityUnits.MB]: 1e6,
  [CapacityUnits.GB]: 1e9,
  [CapacityUnits.TB]: 1e12,
};
